// Festival Map - Optimized Interactive Features
(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const svgContainer = document.getElementById('festival-map-svg');
    if (!svgContainer) return;

    const legendItems = document.querySelectorAll('.festival-map-section .legend-item');
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    
    // State management
    const state = {
      activeElement: null,
      highlightedElement: null,
      tooltipTimeout: null,
      scale: isMobile ? 2 : 1,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      lastX: 0,
      lastY: 0,
      startX: 0,
      startY: 0,
      svgElement: null
    };
    
    // Pin IDs
    const pinIds = [
      'A1', 'A2', 'A3', 'A4', 'A5',
      'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'B11', 'B12',
      'F1', 'F2', 'F3', 'F4',
      'Masterclass_Room', 'Registration', 'Entrance', 'Exit', 'Spin_The_Wheel',
      'Toilet', 'Photo_Booth', 'Stage', 'Dining_Hall', 'VIP_LOUNGE'
    ];
    
    // Name mappings
    const nameMap = {
      'Masterclass_Room': 'Masterclass Room',
      'Spin_The_Wheel': 'Spin The Wheel',
      'Photo_Booth': 'Photo Booth by Dollop',
      'Dining_Hall': 'Dining Hall',
      'VIP_LOUNGE': 'VIP Lounge'
    };
    
    // Create and configure tooltip
    const tooltip = createTooltip();
    
    // Load and inject SVG inline
    loadInlineSVG();
    
    // Setup legend interactions
    setupLegendInteractions();
    
    // ============ SVG Loading Function ============
    
    function loadInlineSVG() {
      const svgUrl = svgContainer.getAttribute('data-svg-url') || 'champagniac-2025-event-map.svg';
      
      fetch(svgUrl)
        .then(function(response) { return response.text(); })
        .then(function(svgText) {
          // Parse SVG and inject into container
          const parser = new DOMParser();
          const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
          const svgElement = svgDoc.querySelector('svg');
          
          if (svgElement) {
            // Add class for styling
            svgElement.classList.add('map-svg');
            
            // Replace span content with SVG
            svgContainer.innerHTML = '';
            svgContainer.appendChild(svgElement);
            
            // Store reference
            state.svgElement = svgElement;
            
            // Initialize interactions
            initializeSVG(svgElement);
            setupPanControls(svgElement);
            setupPinInteractions(svgElement);
          }
        })
        .catch(function(error) { 
          console.error('Error loading SVG:', error); 
        });
    }
    
    // Add mobile hint
    if (isMobile) showMobileHint();
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // ============ Helper Functions ============
    
    function createTooltip() {
      const tip = document.createElement('div');
      tip.style.cssText = 
        'position: fixed; background: rgba(0,0,0,0.9); color: white;' +
        'padding: ' + (isMobile ? '12px 16px' : '8px 12px') + ';' +
        'border-radius: ' + (isMobile ? '12px' : '8px') + ';' +
        'font-size: ' + (isMobile ? '15px' : '14px') + ';' +
        'pointer-events: ' + (isMobile ? 'auto' : 'none') + ';' +
        'opacity: 0; transition: opacity 0.3s; z-index: 1000;' +
        'white-space: ' + (isMobile ? 'normal' : 'nowrap') + ';' +
        'max-width: ' + (isMobile ? '280px' : '300px') + ';' +
        'box-shadow: 0 4px 12px rgba(0,0,0,0.3);' +
        'text-align: center; line-height: 1.4;' +
        'cursor: ' + (isMobile ? 'pointer' : 'default') + ';';
      
      if (isMobile) {
        tip.addEventListener('click', function() {
          tip.style.opacity = '0';
          clearTimeout(state.tooltipTimeout);
        });
      }
      
      document.body.appendChild(tip);
      return tip;
    }
    
    function initializeSVG(svg) {
      if (isMobile) {
        svg.style.transformOrigin = 'center center';
        svg.style.transform = 'scale(' + state.scale + ') translate(' + state.translateX + 'px, ' + state.translateY + 'px)';
        svg.style.transition = 'transform 0.3s ease';
      }
    }
    
    function setupPanControls(svg) {
      if (!isMobile) return;
      
      const constrainTranslation = function(tx, ty) {
        const container = svgContainer.parentElement;
        const rect = svg.getBoundingClientRect();
        const maxX = (rect.width / state.scale * state.scale - container.offsetWidth) / (2 * state.scale);
        const maxY = (rect.height / state.scale * state.scale - container.offsetHeight) / (2 * state.scale);
        
        return {
          x: Math.max(-maxX, Math.min(maxX, tx)),
          y: Math.max(-maxY, Math.min(maxY, ty))
        };
      };
      
      const updateTransform = function() {
        svg.style.transform = 'scale(' + state.scale + ') translate(' + state.translateX + 'px, ' + state.translateY + 'px)';
      };
      
      const startDrag = function(x, y) {
        state.isDragging = true;
        state.startX = x;
        state.lastX = state.translateX;
        state.lastY = state.translateY;
        svg.style.transition = 'none';
        document.body.style.overflow = 'hidden';
      };
      
      const doDrag = function(x, y) {
        if (!state.isDragging) return false;
        
        const deltaX = (x - state.startX) / state.scale;
        const deltaY = (y - state.startY) / state.scale;
        const constrained = constrainTranslation(state.lastX + deltaX, state.lastY + deltaY);
        
        state.translateX = constrained.x;
        state.translateY = constrained.y;
        updateTransform();
        return true;
      };
      
      const endDrag = function() {
        state.isDragging = false;
        svg.style.transition = 'transform 0.3s ease';
        document.body.style.overflow = '';
      };
      
      // Touch events
      svg.addEventListener('touchstart', function(e) {
        if (e.touches.length === 1) {
          startDrag(e.touches[0].clientX, e.touches[0].clientY);
          state.startY = e.touches[0].clientY;
        }
      }, { passive: false });
      
      svg.addEventListener('touchmove', function(e) {
        if (e.touches.length === 1 && doDrag(e.touches[0].clientX, e.touches[0].clientY)) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, { passive: false });
      
      svg.addEventListener('touchend', endDrag);
      
      // Mouse events (desktop testing)
      svg.addEventListener('mousedown', function(e) {
        if (!isMobile) {
          startDrag(e.clientX, e.clientY);
          state.startY = e.clientY;
          e.preventDefault();
        }
      });
      
      svg.addEventListener('mousemove', function(e) {
        if (!isMobile && doDrag(e.clientX, e.clientY)) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
      
      svg.addEventListener('mouseup', endDrag);
      svg.addEventListener('mouseleave', function() { 
        if (state.isDragging) endDrag(); 
      });
    }
    
    function setupPinInteractions(svgElement) {
      pinIds.forEach(function(id) {
        const element = svgElement.getElementById(id);
        if (!element) return;
        
        // Initialize pin styles
        element.style.cursor = 'pointer';
        element.style.transition = 'all 0.3s ease';
        element.style.opacity = '0.7';
        
        // Desktop hover
        if (!isMobile) {
          element.addEventListener('mouseenter', function() {
            if (state.activeElement !== element) element.style.opacity = '1';
            showTooltip(element, id);
          });
          
          element.addEventListener('mouseleave', function() {
            if (state.activeElement !== element) element.style.opacity = '0.7';
            tooltip.style.opacity = '0';
          });
        }
        
        // Click/tap
        element.addEventListener('click', function() {
          setActiveElement(element);
          removeYellowHighlight();
          highlightLegendItem(id);
          if (isMobile) showTooltip(element, id, 4000);
        });
      });
    }
    
    function setupLegendInteractions() {
      legendItems.forEach(function(item) {
        const codeEl = item.querySelector('.code');
        const code = codeEl ? codeEl.textContent.trim() : null;
        if (!code) return;
        
        item.addEventListener('click', function() {
          const element = state.svgElement ? state.svgElement.getElementById(code) : null;
          
          if (element) {
            setActiveElement(element);
            addYellowHighlight(element);
            svgContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            highlightLegendItem(code);
            
            if (isMobile) {
              setTimeout(function() { showTooltip(element, code, 4000); }, 600);
            }
          }
        });
        
        // Desktop hover
        if (!isMobile) {
          item.addEventListener('mouseenter', function() {
            const element = state.svgElement ? state.svgElement.getElementById(code) : null;
            if (element && state.activeElement !== element) element.style.opacity = '0.5';
          });
          
          item.addEventListener('mouseleave', function() {
            const element = state.svgElement ? state.svgElement.getElementById(code) : null;
            if (element && state.activeElement !== element) element.style.opacity = '0.7';
          });
        }
        
        if (isMobile) item.style.cursor = 'pointer';
      });
    }
    
    function setActiveElement(element) {
      if (state.activeElement && state.activeElement !== element) {
        state.activeElement.style.opacity = '0.7';
      }
      state.activeElement = element;
      element.style.opacity = '1';
    }
    
    function addYellowHighlight(element) {
      removeYellowHighlight();
      state.highlightedElement = element;
      element.style.outline = '2px solid yellow';
      element.style.outlineOffset = '2px';
      element.style.borderRadius = '100px';
    }
    
    function removeYellowHighlight() {
      if (state.highlightedElement) {
        state.highlightedElement.style.outline = '';
        state.highlightedElement.style.outlineOffset = '';
        state.highlightedElement.style.borderRadius = '';
        state.highlightedElement = null;
      }
    }
    
    function showTooltip(element, id, autoHide) {
      autoHide = autoHide || 0;
      const text = findLegendText(id);
      if (!text) return;
      
      tooltip.textContent = text;
      tooltip.style.background = getPinColor(id);
      
      const rect = element.getBoundingClientRect();
      tooltip.style.left = rect.left + rect.width / 2 + 'px';
      tooltip.style.top = rect.top - 10 + 'px';
      tooltip.style.transform = 'translate(-50%, -100%)';
      tooltip.style.opacity = '1';
      
      if (autoHide) {
        clearTimeout(state.tooltipTimeout);
        state.tooltipTimeout = setTimeout(function() { 
          tooltip.style.opacity = '0'; 
        }, autoHide);
      }
    }
    
    function getPinColor(id) {
      if (id.indexOf('A') === 0) return 'linear-gradient(135deg, #AFBA06 0%, #8FA005 100%)';
      if (id.indexOf('B') === 0) return 'linear-gradient(135deg, #E14592 0%, #C91875 100%)';
      if (id.indexOf('F') === 0) return 'linear-gradient(135deg, #264A9F 0%, #1E3A7F 100%)';
      return 'rgba(0, 0, 0, 0.9)';
    }
    
    function findLegendText(code) {
      if (nameMap[code]) return nameMap[code];
      
      for (var i = 0; i < legendItems.length; i++) {
        var item = legendItems[i];
        var el = item.querySelector('.code');
        if (el && el.textContent.trim() === code) {
          return code + ': ' + item.textContent.replace(code, '').trim();
        }
      }
      return code;
    }
    
    function highlightLegendItem(code) {
      for (var i = 0; i < legendItems.length; i++) {
        var item = legendItems[i];
        item.style.background = '';
        item.style.padding = '';
        item.style.borderRadius = '';
        item.style.transition = '';
      }
      
      for (var j = 0; j < legendItems.length; j++) {
        var item = legendItems[j];
        var codeEl = item.querySelector('.code');
        if (codeEl && codeEl.textContent.trim() === code) {
          item.style.background = 'rgba(255, 255, 255, 0.15)';
          item.style.padding = '8px';
          item.style.borderRadius = '8px';
          item.style.transition = 'all 0.3s';
          break;
        }
      }
    }
    
    function showMobileHint() {
      const hint = document.createElement('div');
      hint.style.cssText = 
        'position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%);' +
        'background: rgba(0, 0, 0, 0.8); color: white; padding: 10px 20px;' +
        'border-radius: 25px; font-size: 13px; z-index: 999; opacity: 0;' +
        'transition: opacity 0.3s; pointer-events: none; text-align: center; max-width: 80%;';
      hint.textContent = 'Drag to pan • Tap pins for details';
      document.body.appendChild(hint);
      
      setTimeout(function() {
        hint.style.opacity = '1';
        setTimeout(function() {
          hint.style.opacity = '0';
          setTimeout(function() { hint.remove(); }, 300);
        }, 4000);
      }, 500);
    }
  }
})();
